export default __webpack_public_path__ + "static/media/deferencer_un_contenu.3a511e20.jpg";